var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerimetrionYards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#0D5093"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3826_344",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3826_344",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerimetrionYards);
export default __webpack_public_path__ + "static/media/perimetrion_yards.037f98f98471184e8c469d1d363d109e.svg";
export { ForwardRef as ReactComponent };